export const injectGlobalsAndResets = document.documentElement.getAttribute('data-wf-style-reset') !== null
